// extracted by mini-css-extract-plugin
export default {"counter":"Counter_counter__s5uns","value":"Counter_value__6sjjh","name":"Counter_name__WBabR","button":"Counter_button__wT+il"};